import CVSection from "./CVSection";

export default CVSection;
